export default __webpack_public_path__ + "static/media/zawodnik10.fbfbe1b7.png";